/*
 * COPYRIGHT:     Copyright © 2021 Xplorie LLC
 * Warning:       This product is protected by United States and international copyright laws.
 *                Unauthorized use or duplication of this software, in whole or in part, is prohibited.
 */
export const CLOSURE_TYPE = 'CLOSURE'
export const SCHEDULE_TYPE = 'SCHEDULE'
export const FULL_WEEK_VALUE = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN']
